import React from "react";
import Navbar from "../components/Home/Navbar";
import Footer from "../components/Home/Footer";
import { Download, ShieldAlert, Monitor } from "lucide-react";

const DownloadPage = () => {
  // 🔴 Ensure your .env file has this variable, or paste the link string here directly
  const downloadUrl = process.env.REACT_APP_DOWNLOAD_LINK || "YOUR_GITHUB_LINK_HERE";

  return (
    <div className="min-h-screen bg-orange-50 font-sans text-stone-900">
      <Navbar />

      {/* --- Header Section --- */}
      <section className="bg-orange-600 text-white py-16 px-4 text-center relative overflow-hidden">
        <div className="absolute inset-0 opacity-10 pointer-events-none flex justify-center items-center">
          <span className="text-[20rem] font-serif">ॐ</span>
        </div>
        
        <div className="relative z-10">
          <Monitor className="mx-auto mb-4 text-orange-200" size={40} />
          <h1 className="text-4xl md:text-5xl font-serif font-bold mb-4">
            Download Desktop App
          </h1>
          <p className="text-orange-100 text-lg max-w-2xl mx-auto">
            Experience the temple management system with faster performance and offline access on Windows.
          </p>
        </div>
      </section>

      {/* --- Main Content Area --- */}
      <main className="max-w-6xl mx-auto px-4 -mt-10 mb-20 relative z-10">
        <div className="bg-white p-8 md:p-12 rounded-[2rem] shadow-xl border-t-8 border-orange-500">
          
          <div className="flex items-center gap-3 text-orange-600 mb-10 justify-center">
            <Download size={32} />
            <h2 className="text-3xl font-serif font-bold text-stone-800">
              Windows Installer
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            
            {/* --- Left Column: Download Action --- */}
            <div className="space-y-8 flex flex-col justify-center">
              <div>
                <h4 className="text-sm font-black text-stone-400 uppercase tracking-widest mb-2">
                  Current Version
                </h4>
                <div className="flex items-baseline gap-3">
                  <span className="text-5xl font-bold text-stone-800">v0.1.0</span>
                  <span className="text-green-600 bg-green-100 px-3 py-1 rounded-md text-sm font-bold">
                    Latest
                  </span>
                </div>
                <p className="text-stone-500 mt-3 text-base">
                  File size: ~130MB • Windows 10/11 (64-bit)
                </p>
              </div>

              {/* Big Download Button */}
              <a 
                href={downloadUrl}
                className="w-full bg-orange-600 text-white px-8 py-8 rounded-2xl font-bold hover:bg-orange-700 transition-all shadow-xl shadow-orange-200 flex items-center justify-center gap-5 active:scale-95 group"
              >
                <div className="bg-white/20 p-3 rounded-xl group-hover:scale-110 transition-transform">
                    <Download size={40} />
                </div>
                <div className="text-left">
                    <div className="text-base font-medium text-orange-100 uppercase tracking-wider">Click to Install</div>
                    <div className="text-2xl">Download .exe</div>
                </div>
              </a>

              <p className="text-sm text-stone-400 italic">
                * Requires Windows 10 or higher.
              </p>
            </div>

            {/* --- Right Column: Installation Guide (Warning Box) --- */}
            <div className="bg-orange-50 p-8 md:p-10 rounded-3xl border border-orange-100">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-12 h-12 bg-stone-800 text-white rounded-full flex items-center justify-center">
                  <ShieldAlert size={24} />
                </div>
                {/* INCREASED FONT SIZE HERE */}
                <h4 className="text-lg font-black text-stone-800 uppercase tracking-widest">
                  Installation Guide
                </h4>
              </div>

              <div className="space-y-8">
                {/* INCREASED FONT SIZE HERE */}
                <p className="text-base text-stone-700 italic border-l-4 border-orange-300 pl-4 py-1">
                  Note: Windows may treat this as "unrecognized" because it is a private application. This is normal.
                </p>

                {/* Step 1 */}
                <div className="flex gap-5">
                    <div className="w-10 h-10 bg-white text-orange-600 font-bold text-xl rounded-full flex items-center justify-center shadow-sm shrink-0">1</div>
                    <div>
                        {/* INCREASED FONT SIZE HERE */}
                        <h5 className="font-bold text-stone-800 text-lg">Browser Warning</h5>
                        <div className="text-base text-stone-600 mt-2 leading-relaxed">
                            If Chrome says "file is not commonly downloaded":
                            <ul className="list-disc ml-5 mt-1 space-y-1">
                                <li>Click the <strong>3 dots</strong> (or arrow).</li>
                                <li>Select <strong>Keep</strong>.</li>
                                <li>Select <strong>Keep Anyway</strong>.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Step 2 */}
                <div className="flex gap-5">
                    <div className="w-10 h-10 bg-white text-orange-600 font-bold text-xl rounded-full flex items-center justify-center shadow-sm shrink-0">2</div>
                    <div>
                        {/* INCREASED FONT SIZE HERE */}
                        <h5 className="font-bold text-stone-800 text-lg">Windows SmartScreen</h5>
                        <div className="text-base text-stone-600 mt-2 leading-relaxed">
                            If you see a blue "Protected your PC" popup:
                            <ol className="list-decimal ml-5 mt-1 space-y-1">
                                <li>Click <span className="underline decoration-orange-400 font-medium">More info</span> (under the text).</li>
                                <li>Click the <span className="font-bold text-stone-800 bg-gray-200 px-1 rounded">Run anyway</span> button.</li>
                            </ol>
                        </div>
                    </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default DownloadPage;